<template>
  <div class="page-contact-pro">
    <section class="page-contact-pro__form-section">
      <div class="form-section container">
        <h1 class="form-section__title">
          Jeden Tag leiten wir Anfragen von Einzelpersonen und Unternehmen an
          unsere Spezialisten weiter. Jetzt als Profi registrieren!
        </h1>

        <div class="form-section__wrapper">
          <div class="form-section__column form-section__form">
            <div class="form__container container">
              <h2 class="form__title">
                Fordern Sie ein kostenloses Informationsgespräch an!
              </h2>

              <ContactProForm
                confirmation-path="/kontakt-fur-unternehmen/bestatigt"
              />
            </div>
          </div>

          <div class="form-section__column form-section__info">
            <MapGermany text="braucht einen Makler." />

            <p class="info__body">
              Jeden Tag verlangen mehr als 1000 Privatpersonen und Unternehmen
              nach unseren Spezialisten
            </p>
          </div>
        </div>
      </div>
    </section>

    <div class="page-contact-pro__usps">
      <div class="container">
        <h2 class="usps__title">Wir vermitteln Ihnen Neukunden</h2>
        <p class="usps__body">
          Profitieren Sie von einer All-in-One-Marketinglösung. Wir tragen zum
          Wachstum Ihres Kundenstammes bei.
        </p>

        <Usps :columns="usps.length" :usps="usps" />
      </div>
    </div>
  </div>
</template>

<script>
import ContactProForm from 'chimera/all/components/form/contact/ContactProForm'
import Usps from 'chimera/all/themes/blueflow/components/Usps'
import MapGermany from 'chimera/all/components/lottie/MapGermany'
import AbstractPage from 'chimera/all/components/page/AbstractPage'

export default {
  name: 'ContactProPage',

  components: {
    ContactProForm,
    Usps,
    MapGermany,
  },

  extends: AbstractPage,

  layout: 'contact-pro',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Melden Sie sich als Partner an',
      headDescription:
        'Möchten Sie auch Leads von Maklervergleicher.de erhalten? Dann melden Sie sich über das Kontaktformular an. Es ist möglich, Interessenten in Ihrer Region zu kontaktieren!',
      path: '/kontakt-fur-unternehmen',
      usps: [
        {
          text: 'Potenzielle Kunden aus Ihrem eigenen Arbeitsbereich!',
          logo: require('chimera/all/themes/blueflow/images/usps/place.svg'),
        },
        {
          text: 'Entscheiden Sie selbst, wie viele Anfragen Sie erhalten möchten.',
          logo: require('chimera/all/themes/blueflow/images/usps/shopping-cart.svg'),
        },
        {
          text: 'Erhalten Sie interessante Angebotsanfragen.',
          logo: require('chimera/all/themes/blueflow/images/usps/offer.svg'),
        },
        {
          text: 'Kostenlose Registrierung ohne Vertragslaufzeit.',
          logo: require('chimera/all/themes/blueflow/images/usps/wallet.svg'),
        },
      ],
    }
  },
}
</script>
